import React, { useEffect, useState } from 'react';
import Axios from '../../../../common/util/Axios';
import store from '../../../../store';
import styles from './ModifierGroupAttach.module.css';

const ModifierGroupAttach = ({ companyId, selectedIds, onChange, disabled }) => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    const load = async () => {
      const nextCompanyId = companyId || store.getState().authState.companyId;
      if (!nextCompanyId) return;
      try {
        const res = await Axios.get('/api/dashboard/modifiers/groups', {
          params: { companyId: nextCompanyId },
        });
        const rows = Array.isArray(res.data?.data) ? res.data.data : res.data || [];
        setGroups(Array.isArray(rows) ? rows : []);
      } catch (_) {
        setGroups([]);
      }
    };
    load();
  }, [companyId]);

  const selected = new Set((selectedIds || []).map(String));

  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(String(id))) {
      next.delete(String(id));
    } else {
      next.add(String(id));
    }
    onChange([...next]);
  };

  if (!groups.length) {
    return (
      <p className={styles.hint}>
        No modifier groups yet. Create them under Inventory → Modifiers.
      </p>
    );
  }

  return (
    <div className={styles.list}>
      {groups.map((group) => (
        <label key={group.id} className={styles.row}>
          <input
            type="checkbox"
            disabled={disabled}
            checked={selected.has(String(group.id))}
            onChange={() => toggle(group.id)}
          />
          <span>
            {group.name}
            {group.isRequired ? ' (required)' : ''}
          </span>
        </label>
      ))}
    </div>
  );
};

export default ModifierGroupAttach;
